'use strict';

const BasePresenter = require('./base');

class InfoPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    const quantitySelected = this.model.get('selectedQuantity');
    const quantity = quantitySelected ? quantitySelected.getPartySize() : 1;

    const selectedPrice = this.model.get('selectedPrice');
    const optionSelected = selectedPrice != null;
    const displayPrice = selectedPrice || this.model.get('sections').getCheapest();
    const displayDiscount = selectedPrice || this.model.get('sections').getMostDiscounted();
    const price = this.formatMoney(displayPrice.getPrice() * quantity, displayPrice.getPriceCurrencyCode());
    const savings = this.formatMoney(displayPrice.getSavings() * quantity, displayPrice.getPriceCurrencyCode());
    const value = this.formatMoney(displayPrice.getValue() * quantity, displayPrice.getValueCurrencyCode());
    const discount = displayDiscount.getDiscount();
    const discountEnabled = this.model.discountEnabled();

    const isReadyToBook = this.model.isReadyToBook();
    const useConsistentPriceBadging = this.model.get('useConsistentPriceBadging');

    return {
      optionSelected,
      quantitySelected,
      price,
      savings,
      value,
      discount,
      discountEnabled,
      isReadyToBook,
      useConsistentPriceBadging,
    };
  }

  formatMoney(amountCents, currencyCode) {
    const formattedCurrency = I18n.toCurrency(amountCents / 100, { currencyCode });
    const trailingZerosRegex = /[,\.]00(?!\d)/;
    return formattedCurrency.replace(trailingZerosRegex, '');
  }
}

module.exports = InfoPresenter;
